/** Home is public; every other frontend route requires a signed-in referred wallet. */
export function canAccessRoute(
  pathname: string,
  state: { isSignedIn: boolean; needsReferral: boolean },
): boolean {
  return pathname === '/' || (state.isSignedIn && !state.needsReferral)
}
